import { Header } from 'react-frontier';

var Settings =()=>{
	return <div className="team-check-screen">
		<Header text="Ajustes" />
	</div>;
};

export default Settings;
